import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const RestrictedPage: LoadableType<any> = LoadableAfterPaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RestrictedPage" */ '../src/RestrictedPage.tsx'))
			.RestrictedPage,
});
